import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { PATH_CLIENT_LIST } from 'routing/path'
import changeUserPasswordAction from 'actions/admin-user/action.change-user-password'
import { getTranslations } from 'store/admin-translation/reducer.translations'
import { getCurrentUser } from 'store/admin-user/reducer.user-get-current'
import { getChangeUserPasswordPending, getChangeUserPasswordSuccess } from 'store/admin-user/reducer.user-get-current'
import { useCheckPermissions } from 'hooks/use-check-permissions';

const ChangePassword = () => {
  const [submitEnabled, setSubmitEnabled] = useState(true);
  const [changeUserPasswordActionInvoked, setChangeUserPasswordActionInvoked] = useState(false);
  const mounted = useRef(false);
  useEffect(() => {
      mounted.current = true;
      return () => { mounted.current = false; };
  }, []);

  const dispatch = useDispatch()
  const translations = useSelector(getTranslations);
  const currentUser = useSelector(getCurrentUser);
  const changeUserPasswordPending = useSelector(getChangeUserPasswordPending);
  const changeUserPasswordSuccess = useSelector(getChangeUserPasswordSuccess);

  var result = useCheckPermissions();
  if (result) {
    return result;
  }

  if (changeUserPasswordActionInvoked && !changeUserPasswordPending && changeUserPasswordSuccess) {
    return <Navigate to={PATH_CLIENT_LIST} />;
  }

  const handleSubmit = fields => {
    const userCredentials = {
      login: currentUser?.login,
      oldPassword: fields?.oldPassword,
      newPassword: fields?.newPassword
    };

    setSubmitEnabled(false);
    setTimeout(() => mounted.current && setSubmitEnabled(true), 1000);

    dispatch(changeUserPasswordAction(userCredentials, translations));
    setChangeUserPasswordActionInvoked(true);
  };
  
  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .required(translations.warningFieldRequired),
    newPassword: Yup.string()
      .required(translations.warningFieldRequired),
    newPasswordConfirmation: Yup.string()
      .required(translations.warningFieldRequired)
      .oneOf([ Yup.ref('newPassword') ], translations.warningValueInvalid)
  });

  const initialValues = {
    oldPassword: "",
    newPassword: "",
    newPasswordConfirmation: ""
  };

  const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 5);
  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <div className="container">
            <div className="row justify-content-center form-bg-image">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h1 className="mb-0 h3">{currentUser?.passwordExpired ? translations.passwordExpired : translations.changePassword}</h1>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={fields => { handleSubmit(fields) }}>
                    { ({ errors, touched }) => (
                      <Form autoComplete={randomAutoComplete}>
                        <div className="form-group mb-4">
                          <label htmlFor="oldPassword">{translations.oldPassword}</label>
                          <Field id="oldPassword" name="oldPassword" type="password" className={`form-control ${errors.oldPassword && touched.oldPassword ? "is-invalid" : ""}`} />
                          <ErrorMessage name="oldPassword" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group mb-4">
                          <label htmlFor="newPassword">{translations.newPassword}</label>
                          <Field id="newPassword" name="newPassword" type="password" className={`form-control ${errors.newPassword && touched.newPassword ? "is-invalid" : ""}`} />
                          <ErrorMessage name="newPassword" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group mb-4">
                          <label htmlFor="newPasswordConfirmation">{translations.passwordConfirmation}</label>
                          <Field id="newPasswordConfirmation" name="newPasswordConfirmation" type="password" className={`form-control ${errors.newPasswordConfirmation && touched.newPasswordConfirmation ? "is-invalid" : ""}`} />
                          <ErrorMessage name="newPasswordConfirmation" component="div" className="invalid-feedback" />
                        </div>
                        <div className="d-grid">
                          <button id="saveButton" type="submit" className="btn btn-dark" disabled={submitEnabled ? null : 'disabled'}>{translations.changePassword}</button>
                        </div>
                      </Form>
                    )}
                  </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default ChangePassword;
